import { Component, OnInit } from '@angular/core';
import {environment} from '../../../environments/environment';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';

@Component({
  selector: 'app-landing-non-tron',
  templateUrl: './landing-non-tron.component.html',
  styleUrls: ['./landing-non-tron.component.css']
})
export class LandingNonTronComponent implements OnInit {

  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;

  constructor(private rootScopeService: RootScopeService) { }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  ngOnInit() {
    this.getRootScopeData();
    this.cloudBasePath = environment.cloudBasePath;  }
}
